import { Book, Dumbbell, FlaskConical, Monitor, Palette, School } from "lucide-react";

export const galleryImages = [
  "/placeholder.svg?height=400&width=600",
  "/placeholder.svg?height=400&width=600",
  "/placeholder.svg?height=400&width=600",
  "/placeholder.svg?height=400&width=600",
  "/placeholder.svg?height=400&width=600",
  "/placeholder.svg?height=400&width=600",
  "/placeholder.svg?height=400&width=600",
  "/placeholder.svg?height=400&width=600",
];

export const facilities = [
  {
    title: "Modern Classrooms",
    desc: "Spacious, well-lit classrooms equipped with smart boards and comfortable furniture.",
    icon: School,
  },
  {
    title: "Science Laboratory",
    desc: "Fully equipped lab for hands-on experiments and scientific exploration.",
    icon: FlaskConical,
  },
  {
    title: "Computer Lab",
    desc: "State-of-the-art computer lab with high-speed internet and latest educational software.",
    icon: Monitor,
  },
  {
    title: "Library",
    desc: "Extensive collection of books, reference materials, and digital resources.",
    icon: Book,
  },
  {
    title: "Sports Facilities",
    desc: "Playground, indoor games area, and equipment for various sports activities.",
    icon: Dumbbell,
  },
  {
    title: "Art Studio",
    desc: "Creative space for visual arts, crafts, and cultural activities.",
    icon: Palette,
  },
];

export const folderIds: { [key: string]: string } = {
  students: "1-4vRdMaBOhLA9uc5fxNntoTHoMcLdZd4", 
  campus: "1-mtq5s1sin6YBDOb2vKYIcrHL7m4ZWg9",
  events: "10QY8gxdDiN1KH7Ww1EFROtWFT8MHqIQo",
  achievements: "1NYjQbTkXMy023t8ApLPSAAoWRLUqZjoq",
  facilities: "1X2ojpqtXZdFENxxxahK0EpCIhlWZoQ4S",
  historical: "1_rap_Bo35H436Nq2gAgAtX5RItvNW3Ys",
};

export const heroImages = [
  {
    src: "https://res.cloudinary.com/ds1npuv1v/image/upload/v1742036189/namastee_dpbfhy.jpg",
    alt: "Shree Janakalyan Boarding School campus",
    title: "Welcome to Shree Janakalyan Boarding School",
    subtitle: "Nurturing young minds in Pokhara since 1995",
  },
  {
    src: "https://res.cloudinary.com/ds1npuv1v/image/upload/v1742035677/museum_zvhyqt.jpg",
    alt: "Students in classroom",
    title: "Quality Education",
    subtitle: "Providing excellence in teaching and learning",
  },
  {
    src: "https://res.cloudinary.com/ds1npuv1v/image/upload/v1742036718/teaching_d3cw2g.jpg",
    alt: "School facilities",
    title: "Modern Facilities",
    subtitle: "State-of-the-art infrastructure for optimal learning",
  },
  {
    src: "https://res.cloudinary.com/ds1npuv1v/image/upload/v1742037039/culture_ltagz8.jpg",
    alt: "Cultural activities",
    title: "Cultural Heritage",
    subtitle: "Preserving Nepali traditions and values",
  },
  {
    src: "https://res.cloudinary.com/ds1npuv1v/image/upload/v1742037126/karate_lr7hlt.jpg",
    alt: "Sports activities",
    title: "Active & Healthy Lifestyle",
    subtitle: "Encouraging sports and physical well-being",
  },
  {
    src: "https://res.cloudinary.com/ds1npuv1v/image/upload/v1742037319/parentsday_zexekg.jpg",
    alt: "School event celebration",
    title: "Celebrations and Engaging Activities",
    subtitle: "Annual programs, celebrations, and activities",
  },
  {
    src: "https://res.cloudinary.com/ds1npuv1v/image/upload/v1733810283/viber_image_2024-12-10_08-25-10-489_zgxthr.jpg",
    alt: "Students with teachers",
    title: "Caring Educators",
    subtitle: "Passionate teachers shaping the future",
  },
];

// const dataa: string[] = [
//   'https://res.cloudinary.com/ds1npuv1v/image/upload/v1733810247/viber_image_2024-12-10_08-25-10-250_p3mekf.jpg',
//   'https://res.cloudinary.com/ds1npuv1v/image/upload/v1733810250/viber_image_2024-12-10_08-25-10-299_mpyhie.jpg'
// ]